import { Skeleton as CssModulesSkeleton, StillSkeleton as CssModulesStillSkeleton, type SkeletonProps } from '@sunwebgroup/uds-ui/skeleton'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/skeleton' instead.
 */
export const Skeleton = Object.assign(
  styled(CssModulesSkeleton)<SkeletonProps>``,
  { displayName: 'Skeleton' },
)

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/skeleton' instead.
 */
export const StillSkeleton = Object.assign(
  styled(CssModulesStillSkeleton)<SkeletonProps>``,
  { displayName: 'StillSkeleton' },
)
